import { casesStatusUpdateApi, raiseNotificationApi } from 'Constants'
import { getCaseType, getStringFromNumber,} from 'Utils';
import React, { useEffect, useState } from 'react'
import { Context } from 'Context/Context';
import { useContext } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import TestModal from 'Modals/TestModal';
import CaseCard from './CaseCard';
import { CardStack, CardNotice, CaseBtn, EmptyState } from './CaseListUI';
import useIsMobile from 'Hooks/useIsMobile';

function AllCases({attorney = null, cases, reqRevCountArr, setUpdateComp, emptyText}) {
    const isMobile = useIsMobile();
    const {userDetails, setUserDetails, makeApiCallFunc} = useContext(Context);
    const userInfo = attorney ? attorney?.userId :  userDetails;
    const [isVerified, setIsVerified] = useState(userInfo?.verified);
    const [showEachCase, setShowEachCase] = useState(false);
    const [closeMsg, setCloseMsg] = useState('');
    const [refreshList, setRefreshList] = useState(false);
    const [singleCase, setSingleCase] = useState(null);
    const [requestedCases, setRequestedCases] = useState([]);

    useEffect(()    => {
        if(cases?.length !== 0 && requestedCases?.length === cases?.length) {
            setRequestedCases([]);
            toast.info("Cases requested are moved to requested cases list")
            setUpdateComp((prev) => !prev);
        }
        else
        {
            console.log("Not all cases requested")
        }
    }, [cases, requestedCases])

    
    const raiseNotification = (notificationObj) => {
       
        makeApiCallFunc(
            raiseNotificationApi, 
            notificationObj, 
             (data) => {
                console.log(data);
             },
             (error) => console.log(error),
             null,
            true
            )
    }
    const setIsRequestedTrue = (caseId) => {
        setRequestedCases((prev) => [...prev, caseId]);
    }
    const submit = (index) => { 
       const caseId = cases?.[index]?._id;
       const owner_id = cases?.[index]?.owner;
       const noOfTimesReq = reqRevCountArr?.[caseId]?.denied  ? reqRevCountArr?.[caseId]?.denied : 0;
        console.log(cases);
        makeApiCallFunc(
            casesStatusUpdateApi,
            {
                caseId: caseId,
                userId: userInfo._id,
                assistantId: attorney ? userDetails._id : null,
                caseStatus: "requested"
            },
            ({data}) => {
                console.log("submit req callback", data);
                const updatedUserCase = data?.updatedUserCase;
                setIsRequestedTrue(updatedUserCase?.caseId);
                const notificationObj = {
                        title : (noOfTimesReq !== 0 ?   
                            userDetails?.firstName +" "+ userDetails?.lastName +  ( attorney ?(" on behalf of the legal attorney " + userInfo?.firstName +" " +  userInfo.lastName) : ' ') +" has sent a request for the "+(noOfTimesReq)+" time to this case - " :  userDetails?.firstName +" "+ userDetails?.lastName + ( attorney ? " on behalf of the attorney " + userInfo?.firstName +" "+ userInfo.lastName : '') +" has sent a new request for your case - " )+getCaseType(cases?.[index]?.caseType),
                        is_read : false,
                        sender: "professional",
                        type: "3",
                        notificationCategory: 1,
                        caseNumber: cases?.[index]?.caseNumber,
                        receiver:  owner_id,
                        additionalInfo : {
                            "caseId": caseId,
                            "userId": userDetails._id
                        },
                        content :
                        userDetails?.role === 5 ?
                        "The Law firm case manager "+ userDetails?.firstName +" "+ userDetails?.lastName +" has requested to view your case details.  Please review the Law firm's details and approve or deny their request."+ (noOfTimesReq !==0 ? " Note that the same Law firm has requested to view this case for the "+ getStringFromNumber(noOfTimesReq+1) + " time" : '')
                        :
                        userDetails.isUserFunder ?
                        "A verified Litigation Funder "+ userDetails?.company +"has requested to view your case details.  Please review the Litigation Funder's details and approve or deny their request."+ (noOfTimesReq !==0 ? " Note that the same Funder has requested to view this case for the "+ getStringFromNumber(noOfTimesReq+1) + " time" : '')
                        :
                        (
                            attorney ?
                        "A Verified Legal Assistant "+ userDetails?.firstName +" "+ userDetails?.lastName +" on behalf of the Attorney "+ userInfo?.firstName +" "+ userInfo?.lastName +" has requested to view your case details. Please review the Attorney's details and approve or deny their request."+ (noOfTimesReq !==0 ? " Note that the same Attorney has requested to view this case for the "+ getStringFromNumber(noOfTimesReq+1) + " time" : '')
                            :
                        "A Verified Attorney "+ userDetails?.firstName +" "+ userDetails?.lastName +" has requested to view your case details. Please review the Attorney's details and approve or deny their request."+ (noOfTimesReq !==0 ? " Note that the same Attorney has requested to view this case for the "+ getStringFromNumber(noOfTimesReq+1) + " time" : '')
                        )
                        //content: "A verified Legal Professional "+ userDetails?.firstName +" "+ userDetails?.lastName +" has shown interest on your "+getCaseType(cases?.[index]?.caseType)+" and requested to view your personal and case details. See more details of the Legal Professional to approve or deny." + (noOfTimesReq !==0 ? " Note that the same professional has requested to view this case for the "+ getStringFromNumber(noOfTimesReq+1) + " time" : '')
                }
                raiseNotification(notificationObj);
            },
            (data) => {
                console.log(data)},
               
        )
    }
  if (showEachCase && singleCase) {
    return (
    <TestModal
    onClose={()=>{
                if (closeMsg) {
                    toast.info(closeMsg);
                }
                setShowEachCase(false);   // close modal
                setCloseMsg('');          // reset message
                if(refreshList)
                {
                    setUpdateComp(prev => !prev);
                    setRefreshList(false);
                }
    }}
    uploadNew={showEachCase}
    caseData={singleCase}/>
    )
  }
  if (!cases?.length) {
    return <EmptyState title={emptyText?.title || 'No cases yet'} body={emptyText?.body || 'Cases will appear here as they move into this stage. Try changing your filters.'} />
  }
  return (
    <div className='w-full'>
        {!isVerified &&
            <div className="mb-3 flex items-center justify-between gap-3 flex-wrap py-3 px-4 bg-brass/[.08] border border-brass/[.3] rounded-md font-plexsans font-medium text-[13px] leading-[1.45] text-navy">
                <span>Complete your profile to request cases and see the complete case list.</span>
                <Link to="/attorney/profile" className="font-plexsans font-semibold text-[13px] leading-none text-brass underline">Complete profile</Link>
            </div>}
        <CardStack>
            {cases?.map((detail, key) => {
                const requested = requestedCases.indexOf(detail._id) !== -1;
                const deniedTimes = reqRevCountArr?.[detail?._id]?.denied;
                const pendingClose = reqRevCountArr?.[detail?._id]?.reqToClose;
                const lockedLast = key === (cases?.length - 1) && !isVerified;
                const notices = (pendingClose || deniedTimes) ? <>
                    {pendingClose ? <CardNotice tone="danger">This case is pending closing by the client</CardNotice> : null}
                    {deniedTimes ? <CardNotice tone="warn">You have requested to view this case {deniedTimes} {deniedTimes === 1 ? "time" : "times"} before</CardNotice> : null}
                </> : null;
                return (
                    <CaseCard
                        key={detail?._id || key}
                        detail={detail}
                        userInfo={userInfo}
                        reqRevCountArr={reqRevCountArr}
                        notices={notices}
                        dimmed={lockedLast}
                        overlay={lockedLast ?
                            <div className="absolute inset-0 z-[3] flex items-center justify-center bg-cream/[.55]">
                                <div className="bg-ivory border border-brass/[.35] rounded-lg py-[18px] px-[22px] text-center shadow-[0_16px_36px_-12px_rgba(20,33,61,.4)]">
                                    <div className="font-plexsans font-semibold text-[14px] leading-[1.4] text-navy mb-3">Complete your profile to view more</div>
                                    <Link to="/attorney/profile"><CaseBtn>Complete profile</CaseBtn></Link>
                                </div>
                            </div> : null}
                        actions={isVerified ? (
                            requested
                                ? <CaseBtn variant="muted" disabled full={isMobile}>Requested</CaseBtn>
                                : <CaseBtn onClick={() => submit(key)} full={isMobile} style={isMobile ? { height: '46px', fontSize: '14px' } : undefined}>Request to view more →</CaseBtn>
                        ) : null}
                    />
                )
            })}
        </CardStack>
    </div>
  )
}

export default AllCases;
